import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableContainer from "../../../components/Tables/TableContainer";
import TableCell from "../../BillingAndPayments/components/TableCell";
import { useTranslationApp } from "../../../lib/i18next";
import {
  ADLE_CARD_WAITLIST_ADMIN_COLUMN_SPEND_3M,
  ADLE_CARD_WAITLIST_ADMIN_COLUMN_SPEND_ALL_TIME,
  COLUMN_NAME_AGENCY,
  COLUMN_NAME_BRAND,
  COLUMN_NAME_COUNTRY,
  COLUMN_NAME_CREATED_DATE,
  COLUMN_NAME_EMAIL,
  DATE_SHORT,
  EMPTY_RESULTS_SHOW,
} from "../../../i18n/keysTranslations";
import {
  formatAdSpendCountry,
  formatAdSpendUsd,
} from "./adSpend/adSpendDisplay";

const headerCellProps = { showTooltip: false, isHeader: true };
const bodyCellProps = {
  showTooltip: false,
  isHeader: false,
  showLastRowBorder: true,
};

const firstColSx = {
  paddingLeft: "16px !important",
};

const formatCreated = ({ creationTime, t }) => {
  const time = Number(creationTime);
  if (!Number.isFinite(time) || time <= 0) return "—";
  try {
    return t(DATE_SHORT, { date: new Date(time) });
  } catch {
    return "—";
  }
};

const formatSpend = ({ value, language }) =>
  value == null ? "—" : formatAdSpendUsd({ value, language });

const AdleCardWaitlistTable = ({ rows = [], loading = false }) => {
  const { t, i18n } = useTranslationApp();
  const language = i18n.language;

  return (
    <TableContainer
      loading={loading && rows.length === 0}
      keys={rows}
      hasPagination={false}
      emptyText={EMPTY_RESULTS_SHOW}
      ariaLabel="adle-card-waitlist"
      sxContainer={{ maxHeight: "calc(100vh - 240px)" }}
    >
      <TableHead>
        <TableRow>
          <TableCell {...headerCellProps} sx={firstColSx}>
            {t(COLUMN_NAME_CREATED_DATE)}
          </TableCell>
          <TableCell {...headerCellProps}>{t(COLUMN_NAME_EMAIL)}</TableCell>
          <TableCell {...headerCellProps}>{t(COLUMN_NAME_COUNTRY)}</TableCell>
          <TableCell {...headerCellProps}>{t(COLUMN_NAME_AGENCY)}</TableCell>
          <TableCell {...headerCellProps}>{t(COLUMN_NAME_BRAND)}</TableCell>
          <TableCell {...headerCellProps}>
            {t(ADLE_CARD_WAITLIST_ADMIN_COLUMN_SPEND_ALL_TIME)}
          </TableCell>
          <TableCell {...headerCellProps} resizable={false}>
            {t(ADLE_CARD_WAITLIST_ADMIN_COLUMN_SPEND_3M)}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row, index) => {
          const isLastRow = index === rows.length - 1;
          const countryLabel = formatAdSpendCountry({
            countryCode: row.country,
            t,
          });
          return (
            <TableRow key={row.uid || `${row.email}-${index}`}>
              <TableCell
                {...bodyCellProps}
                isLastRow={isLastRow}
                sx={firstColSx}
              >
                {formatCreated({ creationTime: row.creationTime, t })}
              </TableCell>
              <TableCell {...bodyCellProps} isLastRow={isLastRow}>
                {row.email || "—"}
              </TableCell>
              <TableCell {...bodyCellProps} isLastRow={isLastRow}>
                {countryLabel || "—"}
              </TableCell>
              <TableCell {...bodyCellProps} isLastRow={isLastRow}>
                {row.agencyName || row.agencyID || "—"}
              </TableCell>
              <TableCell {...bodyCellProps} isLastRow={isLastRow}>
                {row.brandName || "—"}
              </TableCell>
              <TableCell {...bodyCellProps} isLastRow={isLastRow}>
                {formatSpend({
                  value: row.adSpendAllTimeUSD,
                  language,
                })}
              </TableCell>
              <TableCell {...bodyCellProps} isLastRow={isLastRow}>
                {formatSpend({
                  value: row.adSpendLast3MonthsUSD,
                  language,
                })}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </TableContainer>
  );
};

export default AdleCardWaitlistTable;
